import { createI18nConfig } from '@/app/utils';

export const EXAMPLE_PROMPT = createI18nConfig<{ subject: string; environment: string }>(
  {
    en: {
      subject:
        'A girl in a sailor-style school uniform, drinking soda from a glass bottle, sitting on a wooden park bench on a hot summer day',
      environment: 'cicadas buzzing in the background, sunlight filtering through green leaves',
    },
    ja: {
      subject:
        'セーラー服の少女が、暑い夏の日に木製の公園のベンチに座り、ガラス瓶のソーダを飲んでいる背景ではセミの鳴き声が響き',
      environment: '緑の葉を通して日差しが差し込んでいる',
    },
    de: {
      subject:
        'Ein Mädchen in einer Matrosen-Schuluniform, trinkt Limonade aus einer Glasflasche, sitzt an einem heißen Sommertag auf einer Holzbank im Park. Im Hintergrund zirpen Zikaden',
      environment: 'Sonnenlicht flimmert durch die grünen Blätter',
    },
    ko: {
      subject: '무더운 여름날 나무 공원 벤치에 앉아 유리병에 든 탄산음료를 마시는 세일러복을 입은 소녀',
      environment: '초록 잎 사이로 햇살이 스며들고, 매미 소리가 울리는 배경',
    },
    pt: {
      subject:
        'Uma garota de uniforme escolar estilo marinheiro, bebendo refrigerante de uma garrafa de vidro, sentada num banco de madeira no parque, num dia quente de verão cigarras zumbindo ao fundo',
      environment: 'luz do sol se entrelaçando nas folhas verdes',
    },
    ru: {
      subject:
        'Девочка в школьной форме в матросском стиле пьет газировку из стеклянной бутылки, сидя на деревянной скамейке в парке жарким летним днем. Цикады жужжат где-то рядом',
      environment: 'солнечный свет пробивается сквозь зеленую листву',
    },
    fr: {
      subject: `Une fille en uniforme scolaire de style marin, assise sur un banc en bois dans un parc, boit un soda dans une bouteille en verre par une chaude journée d’été
avec les cigales bourdonnant en arrière-plan et la`,
      environment: 'lumière du soleil filtrant à travers les feuilles vertes',
    },
    es: {
      subject:
        'Una chica con uniforme escolar de estilo marinero, bebiendo refresco de una botella de cristal, sentada en un banco de madera del parque en un caluroso día de verano, con cigarras zumbando de fondo',
      environment: 'luz solar filtrándose a través de hojas verdes',
    },
  },
  {
    subject: '一位女孩穿着飘逸的长裙，穿过金黄色的芦苇地',
    environment: '夕阳西下，微风拂过，芦苇轻轻摇曳',
  },
);
